<template>
  <div id="login_container">
    <div class="planet_wraper planet_shadow">
      <div class="planet">
        <div class="crater_1">
        </div>
        <div class="crater_2">
        </div>
        <div class="crater_3">
        </div>
        <div class="crater_4">
        </div>
        <div class="crater_5">
        </div>
      </div>
    </div>
    <div class="login_box">
      <!--标题-->

      <div class="title">
        <!-- 镇海区数字消费地图后台管理系统 -->
        联动停车管理系统
        <!-- <img src="../assets/logo.png" alt=""> -->
      </div>
      <!--登录表单区-->
      <el-form ref="loginFormRef" :model="loginForm" :rules="loginFormRules" class="login_form">
        <!--用户名-->
        <el-form-item prop="userName">
          <el-input v-model="loginForm.userName" prefix-icon="el-icon-user" placeholder="请输入账号"></el-input>
        </el-form-item>
        <!--密码-->
        <el-form-item prop="inputPsw">
          <el-input v-model="loginForm.inputPsw" prefix-icon="el-icon-lock" placeholder="请输入密码" show-password>
          </el-input>
        </el-form-item>
        <!--按钮区域-->
        <el-form-item class="btns">
          <!-- <el-button type="text" icon="el-icon-sort" @click="showDing=true">浙政钉登录</el-button> -->
          <el-button type="info" style="float: right" @click="resetLoginForm">重置</el-button>
          <el-button type="primary"  style="float: right;margin-right: 10px;" @click="login" :loading="loading">登录</el-button>

        </el-form-item>
      </el-form>
    </div>
    <div class="ding_box" v-if="showDing">
      <iframe class="ding"
              src="https://login-pro.ding.zj.gov.cn/oauth2/auth.htm?response_type=code&client_id=zh_szxfdtyy_dingoa&redirect_uri=https%3A%2F%2Fh5-bussiness.nbzhdata.com%3A11443&scope=get_user_info&authType=QRCODE&embedMode=true"
              ref="iframe"></iframe>
      <el-button type="text" icon="el-icon-sort" class="changeLogin" @click="showDing=false">账号密码登录</el-button>
    </div>
    <div class="beian" @click="beian">备案号：浙ICP备17035746号-1</div>
  </div>
</template>

<script>
import md5 from 'js-md5';

export default {
  name: "Login",
  data() {
    return {
      loading: false,
      // 登录表单的数据表单对象
      loginForm: {
        userName: '',
        inputPsw: '',
      },
      queryInfo: {
        userName: '',
        password: '',
      },
      // 表单数据验证规则对象
      loginFormRules: {
        userName: [
          {required: true, message: '请输入账号', trigger: 'blur'},
          {min: 3, max: 10, message: '账号长度为3-10个字符', trigger: 'blur'}],
        inputPsw: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {min: 6, max: 15, message: '密码长度为6-15个字符', trigger: 'blur'}],
      },
      code:null,
      showDing:false
    }
  },
  created() {
    window.addEventListener('message', this.getCode, true);
    document.title = '登录 | 联动停车管理系统'
  },
  methods: {
    async getCode(event) {
      console.log(event)
      this.code = event.data.code
      console.log(this.code)
      if (this.code) {
        window.removeEventListener('message', this.getCode, true);
        await this.dingLogin()
      }
    },
    // 表单重置
    resetLoginForm() {
      this.$refs.loginFormRef.resetFields()
    },
    login() {
      // 表单预验证
      this.$refs.loginFormRef.validate(async valid => {
        //如果没通过与验证就停止
        if (!valid) return this.$message.error('请确认账号密码填写是否正确')
        // 密码md5
        this.loading = true
        this.queryInfo.password = md5(this.loginForm.inputPsw)
        this.queryInfo.userName = this.loginForm.userName
        const res = await this.$http.post('/admin/sys-user/login/password', this.queryInfo)
        this.loading = false
        if (res.code == '0000') {
          this.$message.success('登录成功')
          // 1.将登录成功后的token保存到客户端的sessionStorage中
          //   1)项目中除了登录之外的其他API接口 必须在登录之后才能访问
          //   2)token只应在当前网站打开期间生效 所以将token存在session中
          window.sessionStorage.setItem('token', res.data.token)
          window.sessionStorage.setItem('userName', res.data.userName)
          window.sessionStorage.setItem('id', res.data.id)
          this.$router.push({name: 'sceniclist'})
        } else {
          this.$message.error(res.message)
        }
      })
    },
    async dingLogin() {
      const res = await this.$http.post('/admin/sys-user/login/zzd', {code: this.code})
      if (res.code !== '0000') return this.$message.error(res.message)
      this.$message.success('登录成功')
      // 1.将登录成功后的token保存到客户端的sessionStorage中
      //   1)项目中除了登录之外的其他API接口 必须在登录之后才能访问
      //   2)token只应在当前网站打开期间生效 所以将token存在session中
      window.sessionStorage.setItem('token', res.data.token)
      window.sessionStorage.setItem('userName', res.data.userName)
      window.sessionStorage.setItem('id', res.data.id)
      this.$router.push({name: 'sceniclist'})
    },
    beian(){
      window.open('https://beian.miit.gov.cn')
    }
  }
}
</script>

<style lang="less" scoped>
body {

}

#login_container {
  background-color: #163040;
  background-image: url('data:image/svg+xml;utf8,<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><circle opacity="0.5" fill="%23FFFFFF" cx="28.75" cy="22.338" r="0.713"/><circle opacity="0.2" fill="%23FFFFFF" cx="26.75" cy="79.443" r="0.307"/><circle opacity="0.5" fill="%23FFFFFF" cx="50" cy="41.884" r="0.308"/><circle fill="%23FFFFFF" cx="12.883" cy="42.25" r="0.367"/><circle opacity="0.4" fill="%23FFFFFF" cx="80" cy="72.818" r="0.307"/><circle opacity="0.5" fill="%23FFFFFF" cx="55.625" cy="12.375" r="0.308"/><circle opacity="0.2" fill="%23FFFFFF" cx="73.307" cy="89.375" r="0.308"/><circle opacity="0.5" fill="%23FFFFFF" cx="73" cy="53.884" r="0.308"/><circle opacity="0.5" fill="%23FFFFFF" cx="38.875" cy="89.432" r="0.385"/></svg>');
  background-size: 20rem 20rem;
  background-position: center 0;
  animation: bg 20s linear infinite;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  /*2*/

  .planet_wraper {
    position: absolute;
    //top: 20%;
    top: 20%;
    right: 20%;
    width: 7rem;
    height: 7rem;
    //margin: ;
    border-radius: 50%;
  }

  /* */

  .planet_shadow {
    background: -moz-linear-gradient(top left, #24b88b 20%, #21776f);
    background: -webkit-linear-gradient(top left, #24b88b 20%, #21776f);
    box-shadow: inset 0 -5px 10px rgba(22, 48, 64, 0.5), 0 0 1.5rem rgba(170, 194, 194, 0.3);
  }

  .planet {
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    animation: rotate 15s linear infinite;
    overflow: hidden;
  }

  /* */

  .planet_wraper::before,
  .planet_wraper::after {
    content: '';
    display: block;
    position: absolute;
    border-radius: 50%;
    box-shadow: 0 0.1rem 0.1rem rgba(170, 194, 194, 0.1), inset 0 -0.1rem 0.1rem rgba(170, 194, 194, 0.1);
    animation: rotate 5s linear infinite;
  }

  .planet_wraper::before {
    top: -1.75rem;
    left: -1.75rem;
    width: 11rem;
    height: 11rem;
    animation-delay: 1s;
  }

  .planet_wraper::after {
    top: -2.5rem;
    left: -2.5rem;
    width: 15rem;
    height: 15rem;
  }

  .planet > * {
    position: relative;
    border-radius: 50%;
    background-color: #209b85;
    box-shadow: inset 1px 1px 5px #163040, 0 0 7px #63eed2;
    opacity: 0.3;
  }

  /*  */

  .crater_1 {
    top: 2rem;
    left: 1.5rem;
    width: 0.75rem;
    height: 0.75rem;
  }

  .crater_2 {
    top: -0.75rem;
    left: 5rem;
    width: 2.5rem;
    height: 2.5rem;
    transform: scaleY(0.8) rotateY(-20deg);
  }

  .crater_3 {
    top: 0.5rem;
    left: 2rem;
    width: 1.25rem;
    height: 1.25rem;
  }

  .crater_4 {
    top: -1.5rem;
    left: 3.5rem;
    width: 0.5rem;
    height: 0.5rem;
  }

  .crater_5 {
    top: 1.25rem;
    left: 3.5rem;
    width: 2rem;
    height: 1.5rem;
  }

  @keyframes bg {
    to {
      background-position: center 20rem;
    }
  }

  @keyframes rotate {
    to {
      transform: rotate(360deg)
    }
  }

}


.login_box {
  width: 450px;
  height: 300px;
  background-color: #fff;
  border-radius: 10px;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
}

//
//.avatar_box {
//  height: 100px;
//  width: 100px;
//  border: 1px solid #eee;
//  border-radius: 50%;
//  padding: 10px;
//  box-shadow: 0 0 10px #ddd;
//  position: absolute;
//  left: 50%;
//  transform: translate(-50%, -40%);
//  background-color: white;
//
//  img {
//    width: 100%;
//    height: 100%;
//    border-radius: 50%;
//    background-color: #eee;
//  }
//}
.ding {
  border: none;
  // width: 800px;
  height: 350px;
}
.login_form {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
}

.btns {
  //display: flex;
  //justify-content: flex-end;
}

.el-input {
  margin: 0
}

.title {
  margin-top: 40px;
  color: #2D3A4A;
  font-size: 24px;
  font-weight: 700;
  margin-left: 30px;
}

.ding_box {
  width: 500px;
  height: 450px;
  background-color: #fff;
  border-radius: 10px;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  text-align: center;
  padding-top: 30px;
  position: relative;
  overflow: hidden;
}
.changeLogin{
  position: absolute;
  bottom:20px;
  left: 20px;
}
.beian{
  position: absolute;
  left: 45%;
  top: 80%;
  color: #FFF;
  cursor: pointer;
}
</style>